/* global Vimeo */
import { loadYouTubeIframeAPI, initYouTubePlayer } from './youtube.js';

document.addEventListener('DOMContentLoaded', () => {
    const videoContainers = document.querySelectorAll('.widget-video__container');

    let youtubePlayers = [];
    let vimeoPlayerInstances = [];

    function initVimeoPlayer(videoContainer) {
        const vimeoPlayer = videoContainer.querySelector('.widget-vimeo-player');

        if (!vimeoPlayer) return;

        const options = {
            autoplay: 0,
            muted: 0,
            loop: 1,
        };

        const vimeoPlayerInstance = new Vimeo.Player(vimeoPlayer, options);
        vimeoPlayerInstances.push(vimeoPlayerInstance);
    }

    function loadVimeoIframeAPI() {
        const vimeoScript = document.createElement('script');
        vimeoScript.src = 'https://player.vimeo.com/api/player.js';
        document.head.appendChild(vimeoScript);

        vimeoScript.onload = () => {
            videoContainers.forEach((container) => {
                initVimeoPlayer(container);
            });
        };
    }

    videoContainers.forEach((videoContainer) => {
        const videoType = videoContainer.dataset.type;

        if (videoType === 'youtube') {
            loadYouTubeIframeAPI(() => {
                const player = initYouTubePlayer(videoContainer.querySelector('.widget-youtube-player'));
                youtubePlayers.push(player);
            });
        } else if (videoType === 'vimeo') {
            loadVimeoIframeAPI();
        }
    });
});
